<template>
  <div>
    <div class="md-card md-card-tabs">
      <h4 class="md-card-header font_bold">{{$t('RoiColumnar.title')}}</h4>
      <div class="md-card-content">
        <div v-show="displayChart" class="chart" ref="myEchartPillar" style="height:400px"></div>
        <emptyChart v-show="!displayChart"></emptyChart>
      </div>
    </div>
  </div>
</template>
<script>
  import {mapGetters} from "vuex";
  import EmptyChart from "@/views/dashboard/EmptyChart";

  export default {
  props: {
  },
  components: {
    EmptyChart
  },
  data() {
    return {
      option: {},
      displayChart: true
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.setData();
    });
  },
  methods: {
    setOption() {
      this.option = {
        color: ["#A6D1F9", "#0071EB", "#FE766C", "#FEC07D"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999"
            }
          }
        },
        toolbox: {
          feature: {
            dataView: { show: false, readOnly: false },
            magicType: { show: false, type: ["line", "bar"] },
            restore: { show: false },
            saveAsImage: { show: false }
          }
        },
        legend: {
          data: [
            this.$t("dashboard.Receivables.bought"),
            this.$t("dashboard.paid.amount"),
            this.$t("RoiColumnar.Expected"),
            this.$t("RoiColumnar.Effective")
          ]
        },
        xAxis: [
          {
            type: "category",
            data: [
              "1",
              "2",
              "3",
              "4",
              "5",
              "6",
              "7",
              "8",
              "9",
              "10",
              "11",
              "12"
            ],
            axisPointer: {
              type: "shadow"
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            min: 0,
            max: 250,
            interval: 50,
            axisLabel: {
              formatter: "{value}"
            }
          },
          {
            type: "value",
            min: 0,
            max: 25,
            interval: 5,
            axisLabel: {
              formatter: "{value}%"
            }
          }
        ],
        series: [
          {
            name: this.$t("dashboard.Receivables.bought"),
            type: "bar",
            stack: "12",
            data: []
          },
          {
            name: this.$t("dashboard.paid.amount"),
            barGap: 0,
            type: "bar",
            data: []
          },
          {
            name: this.$t("RoiColumnar.Effective"),
            type: "line",
            yAxisIndex: 1,
            data: []
          },
          {
            name: this.$t("RoiColumnar.Expected"),
            type: "line",
            yAxisIndex: 1,
            data: []
          }
        ]
      };
    },
    setMonth(data) {
      this.setData(data);
    },
    setData(year) {
      if (!year) {
        year = new Date();
        year = moment(year).format("YYYY");
      }

      this.setOption();
      let option = this.option;
      let myChart = echarts.init(this.$refs.myEchartPillar);
      let xAxisData = option.xAxis[0].data;
      xAxisData = xAxisData.map(item => {
        item = year + "-" + item;
        return item;
      });
      let yAxisLeft = option.yAxis[0];
      let yAxisRight = option.yAxis[1];

      option.xAxis[0].data = xAxisData;
      let series = option.series;
      let { statisticData } = this.dashboardInfo;
      if (!statisticData) {
        this.displayChart = false;
        return;
      }
      const { monthlyReturnOnInvestment } = statisticData;
      let volumeDataSort = [];
      let avgExpectedRoiSort = [];
      if (
        statisticData &&
        monthlyReturnOnInvestment &&
        monthlyReturnOnInvestment.length > 0
      ) {
        this.displayChart = true;
        option.series[0].data = monthlyReturnOnInvestment.map(item => {
          return item.totalReceivableVolume;
        });
        option.series[1].data = monthlyReturnOnInvestment.map(item => {
          return item.totalSettledAmount;
        });
        option.series[2].data = monthlyReturnOnInvestment.map(item => {
          return item.avgEffectiveRoi.toFixed(2);
        });
        option.series[3].data = monthlyReturnOnInvestment.map(item => {
          return item.avgExpectedRoi.toFixed(2);
        });
        volumeDataSort = monthlyReturnOnInvestment.sort(function(a, b) {
          return a.totalReceivableVolume - b.totalReceivableVolume;
        });
        avgExpectedRoiSort = [...monthlyReturnOnInvestment].sort(function(a, b) {
          return a.avgEffectiveRoi - b.avgEffectiveRoi;
        });
      } else {
        this.displayChart = false;
      }

      if (volumeDataSort && volumeDataSort.length > 0) {
        yAxisLeft.min = 0;
        yAxisLeft.max = volumeDataSort[volumeDataSort.length - 1].totalReceivableVolume;
        yAxisLeft.interval = Math.floor((yAxisLeft.max - yAxisLeft.min) / 5);
      }

      if (avgExpectedRoiSort && avgExpectedRoiSort.length > 0) {
        yAxisRight.min = 0;
        let originalInterval = (avgExpectedRoiSort[avgExpectedRoiSort.length - 1].avgEffectiveRoi - yAxisRight.min) / 5;
        yAxisRight.interval = this.floorInterval(originalInterval, 0) * 2;
        yAxisRight.max = yAxisRight.interval * 5;
      }

      myChart.setOption(option);
      setTimeout(function() {
        window.addEventListener("resize", () => {
          myChart.resize();
        });
      }, 500);
    },
    floorInterval(value, times) {
      if (value > 0 && value < 1) {
        return this.floorInterval(value * 10, times +1);
      } else {
        return (Math.floor(value) + 1) / Math.pow(10, times);
      }
    }
  },
  computed: {
    ...mapGetters({
      dashboardInfo: "dashboardInfo",
      dashboardFilter: "dashboardFilter"
    })
  },
  watch: {
    dashboardInfo() {
      let { years } = this.dashboardFilter;
      this.setMonth(years);
    }
  }
};
</script>